import { render, staticRenderFns } from "./invitedDetail.vue?vue&type=template&id=0fb2b418&scoped=true&"
import script from "./invitedDetail.vue?vue&type=script&lang=js&"
export * from "./invitedDetail.vue?vue&type=script&lang=js&"
import style0 from "./invitedDetail.vue?vue&type=style&index=0&id=0fb2b418&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb2b418",
  null
  
)

export default component.exports